import { withInstall, withNoopInstall } from '@jdesign-vue/utils'
import Table from './src/table.vue'
import TableColumn from './src/tableColumn'

export const JdTable = withInstall(Table, {
  TableColumn,
})
export default JdTable
export const JdTableColumn = withNoopInstall(TableColumn)

export type TableInstance = InstanceType<typeof Table>

export type TableColumnInstance = InstanceType<typeof TableColumn>

export interface TableConfigContext {
  enableLegacyStyleNoOuterBorder?: boolean
}

export type {
  SummaryMethod,
  Table,
  TableProps,
  TableRefs,
  ColumnCls,
  ColumnStyle,
  CellCls,
  CellStyle,
  TreeNode,
  RenderRowData,
  Sort,
  Filter,
  TableColumnCtx,
} from './src/table/defaults'
